module.exports = __webpack_public_path__ + "static/media/headerM.74bbe808.png";